import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';

export type ApiSource = 'php';

@Injectable({
  providedIn: 'root'
})
export class ApiSwitcherService {
  /** Emits when the API source changes (kept for compat, toujours 'php') */
  apiSourceChanged = new EventEmitter<ApiSource>();

  constructor() {
    this.applyPhp();
  }

  get currentSource(): ApiSource { return 'php'; }
  get activeApiUrl(): string { return environment.apiUrl; }
  get nodeApiUrl(): string { return environment.apiUrl; }
  get phpApiUrl(): string { return environment.phpApiUrl; }

  /** No-op — kept pour compatibilité avec les composants existants */
  switchTo(_source: ApiSource): void { }
  toggle(): void { }

  private applyPhp(): void {
    (environment as any).apiUrl = environment.phpApiUrl;
    (environment as any).uploadedFilesUrl = environment.phpApiUrl + '/filebypath/';
  }
}
